import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { SwiperModule } from "swiper/angular";
import { HomeComponent } from "./home/home.component";
import { CatalogueComponent } from "./catalogue/catalogue.component";
import { NavbarComponent } from "./navbar/navbar.component";
import { FooterComponent } from "./footer/footer.component";
import { EventsComponent } from "./events/events.component";
import { EventsdetailsComponent } from "./eventsdetails/eventsdetails.component";
import { LoginComponent } from "./login/login.component";
import { DonationsComponent } from "./donations/donations.component";
import { CollectingComponent } from "./collecting/collecting.component";
import { OnlineshopComponent } from "./onlineshop/onlineshop.component";
import { AdvisoryBoardComponent } from "./advisory-board/advisory-board.component";
import { ContactformComponent } from "./contactform/contactform.component";
import { AccountComponent } from "./account/account.component";
import { HttpClientModule } from "@angular/common/http";
import { NoopAnimationsModule } from "@angular/platform-browser/animations";
import { MatInputModule } from "@angular/material/input";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { ReactiveFormsModule } from "@angular/forms";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { AutocompleteLibModule } from "angular-ng-autocomplete";

import { FormsModule } from "@angular/forms";
import { AutocompleteModule } from "ng2-input-autocomplete";
import { LinksComponent } from "./links/links.component";
import { ResetpasswordComponent } from "./resetpassword/resetpassword.component";
import { CountdownModule } from "ngx-countdown";
import { PrivacyPolicyComponent } from "./privacy-policy/privacy-policy.component";
import { OnlineshopdetailsComponent } from "./onlineshopdetails/onlineshopdetails.component";
import { UserpageComponent } from "./userpage/userpage.component";
import { ShopproductComponent } from "./shopproduct/shopproduct.component";
import { ToastrModule } from "ngx-toastr";
import { CollectionDetailsComponent } from './collection-details/collection-details.component';
import { UserdetailsComponent } from './userpage/userdetails/userdetails.component';
import { SubscriptionComponent } from "./userpage/subscription/subscription.component";
import { BotComponent } from './bot/bot.component';
import { MemberdirectoryComponent } from './userpage/memberdirectory/memberdirectory.component';
import { MissionStatementComponent } from './mission-statement/mission-statement.component';
import { ErrorPageComponent } from './error-page/error-page.component';
import { PaymentsComponent } from './payments/payments.component';
import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module, RECAPTCHA_SETTINGS, RecaptchaSettings, RecaptchaModule, RecaptchaFormsModule } from 'ng-recaptcha'
import { environment } from "src/environments/environment";
import { EreaderComponent } from './ereader/ereader.component';
import { NgxPaginationModule } from "ngx-pagination";
import { CategoryComponent } from './category/category.component';
import { CategoryitemsComponent } from './categoryitems/categoryitems.component';


@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    CatalogueComponent,
    NavbarComponent,
    FooterComponent,
    EventsComponent,
    EventsdetailsComponent,
    LoginComponent,
    DonationsComponent,
    CollectingComponent,
    OnlineshopComponent,
    AdvisoryBoardComponent,
    ContactformComponent,
    AccountComponent,
    LinksComponent,
    ResetpasswordComponent,
    PrivacyPolicyComponent,
    OnlineshopdetailsComponent,
    UserpageComponent,
    ShopproductComponent,
    CollectionDetailsComponent,
    UserdetailsComponent,
    SubscriptionComponent,
    BotComponent,
    MemberdirectoryComponent,
    MissionStatementComponent,
    ErrorPageComponent,
    PaymentsComponent,
    EreaderComponent,
    CategoryComponent,
    CategoryitemsComponent,
    
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    SwiperModule,
    HttpClientModule,
    FormsModule,
    NoopAnimationsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    MatInputModule,
    MatAutocompleteModule,
    AutocompleteLibModule,
    CountdownModule,
    RecaptchaFormsModule,
    RecaptchaModule,
    NgxPaginationModule,
    ToastrModule.forRoot(),
  ],
  providers: [{  
    provide: RECAPTCHA_SETTINGS,
      useValue: {
        siteKey: environment.googlecaptchasiteKey,
      } as RecaptchaSettings,}
],
  bootstrap: [AppComponent],
})
export class AppModule {}
